import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { reduxForm, Field, FieldArray, formValueSelector, SubmissionError } from 'redux-form';
import { Form, Alert, Button, Row, Col, Modal, Input } from 'antd';
import AntIcon from '../../shared/components/AntIcon';
import { Link } from 'react-router-dom';
import moment from 'moment';

import {
  formItemLayout,
  renderInput,
  renderNumberInput,
  renderDateTime,
  renderSwitch,
  renderTextarea,
  renderSelect,
  wrapFormItemInput,
} from '../../shared/utils/form_components';
import { required } from '../../shared/utils/form_validations';
import ImageUrlFields from './ImageUrlFields';
import BuyLinkFields from './BuyLinkFields';
import RaffleLinkFields from './RaffleLinkFields';
import CommentFields from './CommentFields';

class ReleaseForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modalVisible: false,
      newTagWord: ""
    }
  }
  
  onSubmit(data, _d, { onSubmit }) {
    const toBool = (v) => v === true || v === 'true';
    const hasUnknown = toBool(data.hasUnknownDay);

    const dateMoment = data.date ? moment.utc(data.date) : null;
    if (!dateMoment || !dateMoment.isValid()) {
      return Promise.reject(new SubmissionError({ date: 'Required', _error: 'Please set a valid date.' }));
    }

    let orderPriority = Number(data.orderPriority) || 0;
    if (orderPriority > 90000 && !hasUnknown) {
      orderPriority -= 100000;
    } else if (orderPriority < 10000 && hasUnknown) {
      orderPriority += 100000;
    }

    const date = hasUnknown ? dateMoment.clone().startOf('month').toISOString()
      : dateMoment.toISOString();

    const searchString = [data.title, data.nickname, data.colorway]
      .filter(str => str).map(str => str.toLowerCase()).join(" ");

    const rel = (v) => (v === '' || v == null ? null : v);
    const payload = {
      ...data,
      date,
      orderPriority,
      searchString,
      brand: rel(data.brand),
      tag: rel(data.tag),
      sneakerModel: rel(data.sneakerModel),
      featured: toBool(data.featured),
      hasUnknownDay: hasUnknown,
    };
    return onSubmit(payload);
  }

  UNSAFE_componentWillReceiveProps({ hasStringPrice, change }) {
    if (hasStringPrice !== this.props.hasStringPrice) {
      change('price', null);
    }
  }

  render() {
    const { newTagWord, modalVisible } = this.state;
    const {
      handleSubmit, deleteError, error, submitting, sneakerModels,
      hasStringPrice, deleteButton, tags, brands, raffles, deleteComment, tagCreateHandler
    } = this.props;
    const err = deleteError || error;

    const TagOptions = [{ label: 'Unknown', value: '' }]
      .concat(tags.map(({ _id, title }) => ({ label: title, value: _id })));
    const BrandOptions = [{ label: 'Unknown', value: '' }]
      .concat(brands.map(({ _id, title }) => ({ label: title, value: _id })));
    const SneakerModelOptions = [{ label: 'Unknown', value: '' }]
      .concat(sneakerModels.map(({ _id, name }) => ({ label: name, value: _id })));
    const RaffleOptions = raffles.map(({ _id, name }) => ({ label: name, value: _id }));

    const filterOptions = (value, option) =>
      option.props.children.toLowerCase().includes(value.toLowerCase());

    return (
      <Row>
        <Col lg={{ span: 14, offset: 3 }} md={{ span: 18, offset: 2 }} xs={24}>
          <Form layout="horizontal" component={false} className="ant-form ant-form-horizontal">

            <Form.Item>
              <Row gutter={[8, 8]} type="flex" justify="end" className="page-form-actions">
                <Col>
                  <Button>
                    <Link to="/releases">Cancel</Link>
                  </Button>
                </Col>
                <Col>{deleteButton}</Col>
                <Col>
                  <Button
                    disabled={submitting} loading={submitting}
                    type="primary" htmlType="button"
                    onClick={() => handleSubmit(this.onSubmit)()}
                  >
                    <AntIcon type="save" />Save
                  </Button>
                </Col>
              </Row>
            </Form.Item>

            {err && <Form.Item><Alert message={err} type="error" /></Form.Item>}

            <Field
              name="title"
              placeholder="Title"
              label="Title"
              required
              component={renderInput}
              validate={required}
            />

            <Form.Item
              {...formItemLayout}
              required
              label="Price"
            >
              <Row>
                <Col xs={6} md={4}>
                  {hasStringPrice ? (
                    <Field
                      inputOnly
                      name="price"
                      placeholder="Price label"
                      required
                      component={renderInput}
                      validate={required}
                    />
                  ) : (
                    <Field
                      inputOnly
                      name="price"
                      placeholder="$100"
                      min={0}
                      step={0.1}
                      required
                      component={renderNumberInput}
                      validate={required}
                    />
                  )}
                </Col>
                <Col span={3} offset={1}>
                  <Field
                    name="hasStringPrice"
                    checkedChildren="A"
                    unCheckedChildren="1"
                    component={renderSwitch}
                  />
                </Col>
                <Col md={10} xs={8} offset={6}>
                  <Field
                    inline
                    name="featured"
                    label="Featured"
                    component={renderSwitch}
                  />
                </Col>
              </Row>
            </Form.Item>

            <Form.Item
              {...formItemLayout}
              required
              label="Brand"
            >
              <Row gutter={8} type="flex" align="middle">
                <Col xs={24} md={10} className="release-form__select-col">
                  <Field
                    inputOnly
                    showSearch
                    filterOption={filterOptions}
                    name="brand"
                    placeholder="Unknown"
                    options={BrandOptions}
                    component={renderSelect}
                  />
                </Col>
              </Row>
            </Form.Item>

            <Form.Item
              {...formItemLayout}
              required
              label="Tag"
            >
              <Row
                gutter={[8, 8]}
                type="flex"
                align="middle"
                wrap
                className="release-form__tag-row"
              >
                <Col
                  xs={24}
                  sm={24}
                  md={10}
                  className="release-form__select-col"
                  style={{ minWidth: 0 }}
                >
                  <Field
                    inputOnly
                    showSearch
                    filterOption={filterOptions}
                    name="tag"
                    placeholder="Unknown"
                    options={TagOptions}
                    component={renderSelect}
                  />
                </Col>
                <Col xs={24} sm={24} md={14} className="release-form__tag-actions">
                  <Button
                    type="default"
                    className="release-form__add-tag-btn"
                    onClick={() => this.setState({ modalVisible: true })}
                  >
                    <AntIcon type="plus" /> Add New Tag
                  </Button>
                </Col>
              </Row>
            </Form.Item>

            <Form.Item
              {...formItemLayout}
              required
              label="Model"
            >
              <Row gutter={8} type="flex" align="middle">
                <Col xs={24} md={10} className="release-form__select-col">
                  <Field
                    inputOnly
                    showSearch
                    filterOption={filterOptions}
                    name="sneakerModel"
                    placeholder="Unknown"
                    options={SneakerModelOptions}
                    component={renderSelect}
                  />
                </Col>
              </Row>
            </Form.Item>

            <Field
              name="colorway"
              placeholder="White/Dark/Red"
              label="Color"
              component={renderInput}
            />

            <Field
              name="nickname"
              placeholder="History Of Flight"
              label="Nickname"
              component={renderInput}
            />

            <Form.Item
              {...formItemLayout}
              required
              label="Date"
            >
              <Row gutter={8}>
                <Col span={12}>
                  <Field
                    inputOnly
                    name="date"
                    placeholder="Date"
                    component={renderDateTime}
                    validate={required}
                  />
                </Col>
                <Col span={12}>
                  <Field
                    inline
                    name="hasUnknownDay"
                    label="Unknown Day"
                    component={renderSwitch}
                  />
                </Col>
              </Row>
            </Form.Item>

            <Field
              name="description"
              label="Description"
              autosize={{ minRows: 3 }}
              component={renderTextarea}
            />

            <FieldArray
              name="imageUrls"
              label="Image Urls"
              component={ImageUrlFields}
            />

            <FieldArray
              name="buyLinks"
              label="Buy Links"
              component={BuyLinkFields}
            />

            <FieldArray
              name="raffleLinks"
              label="Raffle Links"
              raffleOptions={RaffleOptions}
              filterOptions={filterOptions}
              component={RaffleLinkFields}
            />

            <FieldArray
              name="resellUrls"
              label="Resell Urls"
              component={ImageUrlFields}
            />

            <FieldArray
              name='comments'
              label="Comments"
              component={CommentFields}
              deleteComment={deleteComment}
            />

          </Form>
        </Col>

        <Modal
            title="Add New Tag"
            open={modalVisible}
            onOk={async () => {
              const newTag = await tagCreateHandler(newTagWord);
              this.setState({
                modalVisible: false,
              });
              if (newTag) {
                this.props.change('tag', newTag[`_id`]);
              }
            }}
            okText="Add"
            onCancel={() => this.setState({ modalVisible: false })}
          >
            {wrapFormItemInput(
              <Input
                className="container__input"
                value={newTagWord}
                onChange={(event) => this.setState({ newTagWord: event.target.value })}
                placeholder="Tag Name"
              />,
            )}
          </Modal>
      </Row>
    )
  }
}

const selector = formValueSelector('ReleaseForm');

export default compose(
  connect(
    (state) => ({
      hasStringPrice: selector(state, 'hasStringPrice'),
    }),
  ),
  reduxForm({
    form: 'ReleaseForm',
    initialValues: {
      hasUnknownDay: false,
      featured: false,
      brand: '',
      tag: '',
      sneakerModel: '',
    },
  })
)(ReleaseForm);
